export default (data) => ({
  clientId: 'MAESTRO.MOS',
  globalId: 'globalId',
  metadata: {
    item: `<MaestroItem><OMData><Page id="${data.sceneID || 'PWTICKER'}" subType="gfx">${data.fields.map((param) => `<Param type="STRING" name="${param.field}" pType="10">${param.value}</Param>`)},<Param type="STRING" name="TEMPLATE_TYPE" pType="10">${data.fields[0].templateType}</Param></Page></OMData></MaestroItem>`,
  },
  priority: 'Low',
  profile: {
    name: 'PNG',
  },
  range: {
    duration: 1,
    start: 30,
  },
  step: 1,
});
